
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/never-miss-important-team-announcements-delayedsend",
      function () {
        return require("private-next-pages/article/never-miss-important-team-announcements-delayedsend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/never-miss-important-team-announcements-delayedsend"])
      });
    }
  